import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "label"]

  async copy() {
    const text = this.sourceTarget.value || this.sourceTarget.textContent
    await navigator.clipboard.writeText(text)

    const label = this.labelTarget
    const original = label.textContent
    label.textContent = "Copiato!"
    setTimeout(() => { label.textContent = original }, 2000)
  }
}
